import { createSelector } from 'reselect';
import { map } from 'lodash';
import { sortAlphaBy } from './generic';

// Those are easy helpers for selectors common operations.
// The typings makes it looks like crazy magics
// but it is needed to get proper type support
export const createLoadingSelector =
  <S extends { loading: { [index: string]: any } }>(actions: any) =>
  (state: S) =>
    !!actions.some((action: any) => state.loading[action]);

export const createErrorSelector =
  <S extends { error: { [index: string]: any } }>(actions: any) =>
  (state: S) =>
    actions.some((action: any) => state.error[action]);

export const createOptionsSelector = <
  S,
  R extends { id: any; [index: string]: any }
>(
  selector: (state: S) => { [index: string]: R },
  propertyName?: string
) =>
  createSelector(selector, (properties: any) =>
    map(properties, (property) => ({
      value: property.id,
      label: (propertyName ? property[propertyName] : property.name) as string
    })).sort(sortAlphaBy('label'))
  );

export const createMapSelector = <S, R>(
  selector: (state: S) => { [index: string]: R }
) => createSelector(selector, (properties: any) => map(properties));
